/**
 * Utility functions for domain management
 */

export function isCustomDomain(host: string | null): boolean {
  if (!host) return false
  const mainDomain = process.env.NEXT_PUBLIC_DOMAIN || 'taylora.com'
  const vercelDomain = 'vercel.app'

  return !host.includes(mainDomain) && !host.includes(vercelDomain)
}

export function getCookieDomain(host: string | null): string | undefined {
  if (!host) return undefined

  if (isCustomDomain(host)) {
    const hostParts = host.split('.')
    if (hostParts.length >= 2) {
      // For domains like client.it or www.client.it
      return `.${hostParts[hostParts.length - 2]}.${
        hostParts[hostParts.length - 1]
      }`
    }
    return host
  }

  return `.${process.env.NEXT_PUBLIC_DOMAIN}`
}
